import { setNavigationBar } from '@docs/common'
import { useEffect } from 'react'

import { Swiper } from 'antd-mobile'
import Banner1 from 'assets/images/bh3/expanding_1.png'
import Banner2 from 'assets/images/bh3/expanding_2.png'
import useTranslation from '../useNewTranslation'

import useLanguageTrans from 'common/useLanguageTrans'
import styles from './index.module.scss'

const Expanding = () => {
  useLanguageTrans()
  const { t } = useTranslation()

  useEffect(() => {
    setNavigationBar({
      title: t('h5_storage_edu_expanding', { defaultValue: 'Expanding Storage' }),
    })
  }, [t])

  return (
    <Swiper
      indicator={(total: number, current: number) => (
        <div className={styles.Indicator}>
          {Array(total).fill(null).map((_, i) => <i key={i} className={current === i ? styles.IndicatorActive : ''}></i>)}
        </div>
      )}
    >
      <Swiper.Item>
        <div className={styles.Expanding}>
          <img src={Banner1} alt="banner" />
          <p>
            {t('h5_storage_edu_expanding_content1', {
              defaultValue:
                'HomeBase 3 has 16 GB of built-in storage and an expansion bay for installing an additional storage drive.\n\nWhen using an additional storage drive, HomeBase can store more video recordings.',
            })}
          </p>
          <p className={styles.ExpandingNote}>
            {t('h5_storage_edu_expanding_content2', {
              defaultValue:
                '*Continuous recording is only available for wired cameras that store recordings on HomeBase 3.',
            })}
          </p>
        </div>
      </Swiper.Item>
      <Swiper.Item>
        <div className={styles.Expanding}>
          <img src={Banner2} alt="banner" />
          <p>
            {t('h5_storage_edu_expanding_hhd1', {
              defaultValue:
                'Both HDD and SSD storage drives that meet the following specifications can be used: \n\n1. Size: 2.5" \n2. Operating Voltage: 5V \n3. Interface: SATA \n4. Capacity: Up to 16 TB',
            })}
          </p>
          <p className={styles.ExpandingNote}>
            {t('h5_storage_edu_expanding_hhd2', {
              defaultValue:
                'We recommend using known brands with a good reputation, such as Seagate, Western Digital, and Samsung.',
            })}
          </p>
        </div>
      </Swiper.Item>
    </Swiper>
  )
}

export default Expanding
